export default __webpack_public_path__ + "static/media/icon-checked.0057d15c.webp";